export enum DefaultListType {
    List = 'list',
    Treeview = 'treeview'
}